import { render } from "./cage-tabset.vue?vue&type=template&id=5a0e92b7"
import script from "./cage-tabset.vue?vue&type=script&lang=js"
export * from "./cage-tabset.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__